export default __webpack_public_path__ + "static/media/000_intro_part1.first.9db318a4.png";